
  import {
    CompanyModel,
    CompositionStockAlias,
    ContactAvailableData
  } from '@/services/api/models'
  import { computed, defineComponent, onMounted, ref, toRefs, watch } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'
  import Multiselect from '@/components/Select/multiselect.vue'
  import { Field } from 'vee-validate'
  import { MAINACTIONS } from '@/types'

  export default defineComponent({
    name: 'DropdownActions',
    components: { Multiselect, Field },
    props: {
      disabled: Boolean,
      data: {
        type: Object,
        default: () => ({
          name: '',
          type: '',
          fieldId: ''
        })
      },
      classItem: {
        type: String,
        default: 'w-full'
      },
      hasLabel: {
        default: true,
        type: Boolean
      },
      value: {
        default: '',
        type: [String, Array]
      },
      mode: {
        default: 'single',
        type: String
      },
      openDirection: {
        type: String,
        default: 'top'
      },
      callback: {
        type: Function,
        default: () => ({})
      },
      canAddNew: { type: Boolean, default: true },
      validationState: { type: String, default: '' },
      dataFromExtra: { type: Boolean, default: false }, //if data is get from contacTExtraData or not
      optionData: {
        type: Object,
        default: () => ({
          value: [],
          index: -1
        })
      },
      tableId: {
        type: String,
        default: null
      },
      index: {
        type: Number,
        default: null
      }
    },
    emits: ['onUpdated'],
    setup(props, { emit }) {
      const store = useStore()

      const { t } = useI18n()
      const route = useRoute()
      const { data } = toRefs(props)
      const searchText = ref('')
      const fieldName =
        props.tableId && props.index !== -1
          ? `${props.tableId}[${props.index}].${data.value.name}`
          : data.value.name

      const addActionSlot = computed(() =>
        props.mode === 'top' ? 'afterlist' : 'beforelist'
      )

      const stocks = computed<CompositionStockAlias[]>(
        () => store.getters[`organizations/compositionStockAlias`]
      )

      const currency = computed(() => store.getters['organizations/currency'])
      const option = ref(props.value)
      const options = ref<any[]>([])

      const openModal = () => {
        store.dispatch('ui/toggleModal', {
          display: true,
          contentType: MAINACTIONS.STOCK
        })
      }

      const updateValue = (selected: string) => {
        option.value = selected
        emit('onUpdated', {
          ...data.value,
          value: selected
        })
      }

      const currentCompany = computed<CompanyModel>(
        () => store.getters['organizations/contextCompany']
      )

      const handleSearch = (search: string) => {
        getCompositions(search)
      }
      const getCompositions = (search?: string) => {
        const filter: any = {}
        if (search) filter.alias = search
        store.dispatch('organizations/GET_COMPOSITION_STOCK_ALIAS', {
          companyId: currentCompany.value?.id,
          filter
        })
      }
      onMounted(() => {
        getCompositions()
      })

      watch(props, (prop) => {
        option.value = prop.value
      })

      return {
        options,
        option,
        handleSearch,
        fieldName,
        addActionSlot,
        searchText,
        stocks,
        updateValue,
        openModal
      }
    }
  })
